import { render, staticRenderFns } from "./parentClass.vue?vue&type=template&id=576ba862&scoped=true&"
import script from "./parentClass.vue?vue&type=script&lang=js&"
export * from "./parentClass.vue?vue&type=script&lang=js&"
import style0 from "./parentClass.vue?vue&type=style&index=0&id=576ba862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ba862",
  null
  
)

export default component.exports